import { snakeCase } from 'lodash';
import { deepMapKeys } from '@core/lib/fp/deepMapKeys';

export const deepKeysToSnakeCase = deepMapKeys(
  key => key.includes('-') ? key : snakeCase(key)
);

export const deepKeysToSnakeCaseWithoutExcluded = (excludedKeys) => deepMapKeys(
  key => key.includes('-') ? key : snakeCase(key),
  excludedKeys,
);
